<template>
    <div class="course__show_versions">
        <component-list
            :component-table="CourseEditVersionsTable"
            :item-name="['version', 'versions']"
            :filters-active="false"
            :get-items-getter="'getEbsCourseVersions'"
        />
    </div>
</template>

<script>
import CourseEditVersionsTable from '@/components/ebs/courses/edit/CourseEditVersionsTable'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'CourseShowVersions',
  components: { ComponentList },
  data () {
    return {
      CourseEditVersionsTable
    }
  }
}
</script>
